import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../../insa-services';

@Component({
  selector: 'activation-form',
  templateUrl: 'activation-form.component.html',
})
export class ActivationFormComponent {
  @Input() email;
  @Input() activationForm: FormGroup;
  private activationError = false;
  @Output() formSubmit = new EventEmitter();
  @Output() activationStateChange = new EventEmitter<{
    isSuccess?: boolean;
    isError?: boolean;
  }>();

  constructor(private _authService: AuthService) {
    _authService.activationSuccessEmitter.subscribe((isSuccess) => {
      if (isSuccess) {
        this.activationStateChange.emit({ isSuccess: true });
        this.activationError = false;
      } else {
        this.activationStateChange.emit({ isError: true });
        this.activationError = true;
      }
    });
  }

  submitActivation() {
    this.formSubmit.emit();
  }

  ngOnInit(): void {
    this.activationForm.valueChanges.subscribe(() => {
      this.activationError = false;
    });
  }

  get activationCode() {
    return this.activationForm.get('activationCode');
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/registration/activation-form.component.ts